<template>
    <div class="main-container" v-if="trailer">
        <div class="first-column">
            <PhotoComponent v-if="trailer.image_url" :imageUrl="trailer.image_url" :altText="trailer.name" />
        </div>
        <div class="second-column">
            <OptionsComponent ref="optionsRef" @options-ready="$emit('options-ready', $event)"
                @section-visible="$emit('section-visible', $event)" />
        </div>
    </div>
</template>

<script>
import PhotoComponent from './PhotoComponent.vue'
import OptionsComponent from './OptionsComponent.vue'
import { useTrailerStore } from '@/stores/trailerStore'
import { getConfigFromStorage } from '@/services/configStorage'
import { API_ROOT } from '@/services/apiService'

export default {
    components: {
        PhotoComponent,
        OptionsComponent
    },
    computed: {
        trailerStore() {
            return useTrailerStore()
        },
        trailer() {
            return this.trailerStore.selectedTrailer
        }
    },
    mounted() {
        const saved = getConfigFromStorage()

        if (saved && saved.trailer && !this.trailerStore.selectedTrailer) {
            const trailerWithImage = {
                ...saved.trailer,
                image_url: saved.trailer.image ? `${API_ROOT}/storage/${saved.trailer.image}` : ''
            }

            const addonsWithImages = saved.addons.map(addon => ({
                ...addon,
                image_url: addon.image ? `${API_ROOT}/storage/${addon.image}` : ''
            }))

            this.trailerStore.selectTrailer(trailerWithImage)
            this.trailerStore.updateSelectedAddons(addonsWithImages)
        }
    },
    methods: {
        scrollToOption(index) {
            this.$refs.optionsRef.scrollToSection(index)
        }
    }
}
</script>

<style scoped lang="scss">
.main-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    max-height: 85vh;
}

.first-column {
    width: 70%;
}

.second-column {
    width: 30%;
    min-height: 94vh;
    padding-bottom: 80px;
    border-left: 1px solid $color-grey;
    overflow-y: auto;
}

@media screen and (max-width: 1100px) {
    .main-container {
        flex-direction: column;
    }

    .first-column,
    .second-column {
        width: 100%;
    }

    .second-column {
        border-left: none;
        border-top: 1px solid $color-grey;
        overflow-y: visible;
        max-height: none;
    }
}
</style>